/**
 * `<FirstRunPanel>` — bundles the paying-tenant first-run welcome moment +
 * getting-started checklist into one mount.
 *
 * Both children self-gate on the server-computed `first_run` flag (via
 * `useGettingStarted`), so this renders nothing for demo tenants, non-
 * provisioned tenants, or once the checklist is complete/dismissed. Mounted at
 * the top of the Dashboard (the app landing surface) in BOTH the no-JDs empty
 * branch and the populated branch.
 */
import { WelcomeMoment } from "@/components/onboarding/WelcomeMoment";
import { GettingStartedChecklist } from "@/components/onboarding/GettingStartedChecklist";

export function FirstRunPanel({
  tenantSlug,
  basePath,
  tenantName,
}: {
  /** Only for WelcomeMoment's per-tenant localStorage key — NOT a link base. */
  tenantSlug: string | undefined;
  /** Prefix-aware link base for the tree this is rendered in — `/${slug}` or
   *  `/${slug}/v1` for v1, `/${slug}/v2` for v2. Built by the parent (v1:
   *  `useTenantV1Base()`, v2: `useTenantBase()`); this component is shared by
   *  both trees and must never assume a tree of its own. */
  basePath: string | undefined;
  tenantName: string | null | undefined;
}): JSX.Element {
  return (
    <>
      <WelcomeMoment tenantSlug={tenantSlug} tenantName={tenantName} />
      <GettingStartedChecklist basePath={basePath} />
    </>
  );
}
